"use strict";

exports.__esModule = true;
exports.parseInstance = void 0;
var atob = typeof self !== 'undefined' ? self.atob.bind(self) : // Accessing 'Buffer' via 'global' prevents webpack polyfilling it for web environment
function (str) {
  return global.Buffer.from(str, 'base64').toString('utf8');
};

var parseInstance = function parseInstance(instance) {
  var _instance$split = instance.split('.', 2),
      base64data = _instance$split[1];

  var data = atob(base64data);
  return JSON.parse(data);
};

exports.parseInstance = parseInstance;